import angular from 'angular';
import { NsjRoutingType } from '@core/nsj-core';
import {
    IMovimentacaoAdmissao,
    IMovimentacaoAdmissaoCreatePayload,
    IMovimentacaoAdmissaoCreateResponse,
    IMovimentacaoAdmissaoUpdatePayload
} from './models/movimentacoes-admissoes.model';

export class MovimentacoesAdmissoesService {
    static $inject = ['$rootScope', '$http', '$q', 'nsjRouting'];

    constructor(
        private $rootScope: angular.IRootScopeService,
        private $http: angular.IHttpService,
        private $q: angular.IQService,
        private nsjRouting: NsjRoutingType
    ) { }

    public list(solicitacao: string): angular.IPromise<IMovimentacaoAdmissao[]> {
        if (!this.isNonEmptyString(solicitacao)) {
            return this.rejectValidation('A solicitação deve ser informada.');
        }

        return this.$q<IMovimentacaoAdmissao[]>((resolve, reject) => {
            this.$http
                .get<IMovimentacaoAdmissao[]>(
                    this.nsjRouting.generate('movimentacoes_admissoes_index', { solicitacao }, true)
                )
                .then((response) => {
                    this.$rootScope.$broadcast('movimentacoes_admissoes_index_loaded', response.data);
                    resolve(response.data);
                })
                .catch((error) => {
                    this.$rootScope.$broadcast('movimentacoes_admissoes_index_error', error);
                    reject(error);
                });
        });
    }

    public get(identifier: string): angular.IPromise<IMovimentacaoAdmissao> {
        if (!this.isNonEmptyString(identifier)) {
            return this.rejectValidation('O identificador da movimentação deve ser informado.');
        }

        return this.$q<IMovimentacaoAdmissao>((resolve, reject) => {
            this.$http
                .get<IMovimentacaoAdmissao>(
                    this.nsjRouting.generate('movimentacoes_admissoes_get', { id: identifier }, true)
                )
                .then((response) => {
                    this.$rootScope.$broadcast('movimentacoes_admissoes_get_loaded', response.data);
                    resolve(response.data);
                })
                .catch((error) => {
                    this.$rootScope.$broadcast('movimentacoes_admissoes_get_error', error);
                    reject(error);
                });
        });
    }

    public create(payload: IMovimentacaoAdmissaoCreatePayload): angular.IPromise<IMovimentacaoAdmissaoCreateResponse> {
        if (!payload || !this.isNonEmptyString(payload.solicitacao)) {
            return this.rejectValidation('A solicitação deve ser informada.');
        }

        return this.$q<IMovimentacaoAdmissaoCreateResponse>((resolve, reject) => {
            this.$http
                .post<IMovimentacaoAdmissaoCreateResponse>(
                    this.nsjRouting.generate('movimentacoes_admissoes_create', {}, true),
                    payload
                )
                .then((response) => {
                    this.$rootScope.$broadcast('movimentacoes_admissoes_create_loaded', response.data);
                    resolve(response.data);
                })
                .catch((error) => {
                    this.$rootScope.$broadcast('movimentacoes_admissoes_create_error', error);
                    reject(error);
                });
        });
    }

    public update(identifier: string, payload: IMovimentacaoAdmissaoUpdatePayload): angular.IPromise<void> {
        if (!this.isNonEmptyString(identifier)) {
            return this.rejectValidation('O identificador da movimentação deve ser informado.');
        }

        return this.$q<void>((resolve, reject) => {
            this.$http
                .put<void>(
                    this.nsjRouting.generate('movimentacoes_admissoes_put', { id: identifier }, true),
                    payload
                )
                .then((response) => {
                    this.$rootScope.$broadcast('movimentacoes_admissoes_put_loaded', response.data);
                    resolve(response.data);
                })
                .catch((error) => {
                    this.$rootScope.$broadcast('movimentacoes_admissoes_put_error', error);
                    reject(error);
                });
        });
    }

    public delete(identifier: string): angular.IPromise<void> {
        if (!this.isNonEmptyString(identifier)) {
            return this.rejectValidation('O identificador da movimentação deve ser informado.');
        }

        return this.$q<void>((resolve, reject) => {
            this.$http
                .delete<void>(
                    this.nsjRouting.generate('movimentacoes_admissoes_delete', { id: identifier }, true)
                )
                .then((response) => {
                    this.$rootScope.$broadcast('movimentacoes_admissoes_delete_loaded', response.data);
                    resolve(response.data);
                })
                .catch((error) => {
                    this.$rootScope.$broadcast('movimentacoes_admissoes_delete_error', error);
                    reject(error);
                });
        });
    }

    public enviar(identifier: string): angular.IPromise<void> {
        if (!this.isNonEmptyString(identifier)) {
            return this.rejectValidation('O identificador da movimentação deve ser informado.');
        }

        return this.$q<void>((resolve, reject) => {
            this.$http
                .post<void>(
                    this.nsjRouting.generate('movimentacoes_admissoes_enviar', { id: identifier }, true),
                    {}
                )
                .then((response) => {
                    this.$rootScope.$broadcast('movimentacoes_admissoes_enviar_loaded', response.data);
                    resolve(response.data);
                })
                .catch((error) => {
                    this.$rootScope.$broadcast('movimentacoes_admissoes_enviar_error', error);
                    reject(error);
                });
        });
    }

    public enviarPorSolicitacao(solicitacao: string): angular.IPromise<void> {
        return this.performSolicitacaoTransition(
            'movimentacoes_admissoes_enviar_lote',
            'movimentacoes_admissoes_enviar_lote_loaded',
            'movimentacoes_admissoes_enviar_lote_error',
            solicitacao
        );
    }

    public excluirPorSolicitacao(solicitacao: string): angular.IPromise<void> {
        return this.performSolicitacaoTransition(
            'movimentacoes_admissoes_excluir_lote',
            'movimentacoes_admissoes_excluir_lote_loaded',
            'movimentacoes_admissoes_excluir_lote_error',
            solicitacao
        );
    }

    private performSolicitacaoTransition(
        routeName: string,
        loadedEvent: string,
        errorEvent: string,
        solicitacao: string
    ): angular.IPromise<void> {
        if (!this.isNonEmptyString(solicitacao)) {
            return this.rejectValidation('A solicitação deve ser informada.');
        }

        return this.$q<void>((resolve, reject) => {
            this.$http
                .post<void>(this.nsjRouting.generate(routeName, { solicitacao }, true), {})
                .then((response) => {
                    this.$rootScope.$broadcast(loadedEvent, response.data);
                    resolve(response.data);
                })
                .catch((error) => {
                    this.$rootScope.$broadcast(errorEvent, error);
                    reject(error);
                });
        });
    }

    private rejectValidation<T = never>(message: string): angular.IPromise<T> {
        return this.$q.reject({
            data: { message },
            status: 400
        });
    }

    private isNonEmptyString(value: unknown): value is string {
        return typeof value === 'string' && value.trim().length > 0;
    }
}
